import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const CCM = {
  heroBackgroundColor: "#fff",
  heroBackgroundIconStart: "#d6d6d6",
  heroBackgroundIconEnd: "#d6d6d6",
  heroTitleTextColor: colors.black,
  heroSubtitleTextColor: colors.black,
  heroAltTitleTextColor: colors.black,
  buttonBackgroundBase: colors.secondary,
  buttonBackgroundHover: colors.secondary,
  buttonText: colors.white
};

const styles = {
  backgroundColor: CCM.heroBackgroundColor,
  "& #hero-icon": {
    fill: "url(#hero-gradient)"
  },
  '& #hero-gradient-start': {
    stopColor: CCM.heroBackgroundIconStart
  },
  '& #hero-gradient-end': {
    stopColor: CCM.heroBackgroundIconEnd
  },
  '& #hero-title': {
    color: CCM.heroTitleTextColor
  },
  '& #hero-alt-title': {
    color: CCM.heroAltTitleTextColor
  },
  '& #hero-subtitle': {
    color: CCM.heroSubtitleTextColor,
  },
  '& #hero-highlighted-text': {
    // color: CCM.heroHighlightedTextColor
  },
  '& .animate__animated': {
    opacity: 0
  },
  '& .animate__fadeInUp': {
    opacity: 1
  }
};

const hero3Styles: any = (theme?: Theme) => styles;

export default hero3Styles;